"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemBase2 = void 0;
var ComponentListenerImpl_1 = require("./ComponentListenerImpl");
var SystemBase_1 = require("./SystemBase");
/**
 * A type of system listening to two components
 * When implementing a system like this, do consider if you are really separating concerns properly or
 * it should really be two separate systems
 * Sometimes there is a need for a system listening to two different components though, and in that case this
 * class can be inherited to reduce a lot of the boilerplate code
 *
 * Note that in order for the system to work it must be registered with the EntityManager
 * and enabled.
 */
var SystemBase2 = /** @class */ (function (_super) {
    __extends(SystemBase2, _super);
    function SystemBase2(component1Id, component2Id) {
        var _this = _super.call(this, component1Id) || this;
        _this.onAddComponent2 = _this.onAddComponent2.bind(_this);
        _this.onUpdateComponent2 = _this.onUpdateComponent2.bind(_this);
        _this.onRemoveComponent2 = _this.onRemoveComponent2.bind(_this);
        _this._componentListeners.push(new ComponentListenerImpl_1.ComponentListenerImpl(_this, component2Id, _this.onAddComponent2, _this.onUpdateComponent2, _this.onRemoveComponent2));
        return _this;
    }
    SystemBase2.prototype.onAddComponent2 = function (_entity, _newComponent) { };
    SystemBase2.prototype.onUpdateComponent2 = function (_entity, _oldComponent, _newComponent) { };
    SystemBase2.prototype.onRemoveComponent2 = function (_entity, _oldComponent) { };
    return SystemBase2;
}(SystemBase_1.SystemBase));
exports.SystemBase2 = SystemBase2;
//# sourceMappingURL=SystemBase2.js.map